import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { Modal } from "../../../theme/Component/Modal";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _OrderTowip } from "../../../../core/services/dataBean/EntityCatalogVdos";

interface Props {
    idProductionOrder: any;
    productionOrderDate: any;
}

export const OrderToWIP = ({ idProductionOrder, productionOrderDate }: Props) => {

    const OrderTowip = useDataBean(_OrderTowip);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        OrderTowip.instance.getProductionOrderToWIPCatalog(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((user) => {

                        user.DataBeanProperties.Doc = (user.DataBeanProperties.Mnemonic ?? "") + "-" + (user.DataBeanProperties.Consecutive ?? "") + "-" + (user.DataBeanProperties.DocumentDate ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        OrderTowip.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        OrderTowip.deleteItemVoid(OrderTowip.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        OrderTowip.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProductionOrderToWIP', visible: true },
        { title: 'Documento de Lidquidación / Cierre', property: 'Doc', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Valor Total', property: 'TotalValue', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Estado', property: 'State', visible: true },
    ]
    const verDocumentos = () => {

        if (OrderTowip.bean) {
            _documentos.instance.getPdfAccountantDocument(OrderTowip.bean.IDDocument, null, OrderTowip.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModalverdoc({ ...modalverdoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Registros de Producto en Proceso">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={OrderTowip.setBean} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} >
                        <div className="row">

                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={OrderTowip.bean.Code} onChange={OrderTowip.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={OrderTowip.bean.Name} onChange={OrderTowip.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">

                            <DocumentViewer
                                list={docs}
                                IDDocument={OrderTowip.bean.IDDocument}
                                Since={OrderTowip.bean.DocumentDate}
                            />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {OrderTowip.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}